export const getPageTitle = (path: string): string => {
  const routes: { match: string; title: string; startsWith?: boolean }[] = [
    { match: '/superadmin/dashboard', title: 'Dashboard' },
    { match: '/superadmin/profile', title: 'Profile' },
    { match: '/superadmin/owner-management', title: 'Owner Management' },
    { match: '/superadmin/alerts', title: 'Notifications & Alerts' },
    { match: '/superadmin/store-management/manufacturers', title: 'Store Management' },
    { match: '/superadmin/store-management', title: 'Store Management' },
    { match: '/superadmin/genie-requests', title: 'Genie Requests' },
    { match: '/superadmin/uploaded-files', title: 'Uploaded Files' },
    { match: '/superadmin/product-import', title: 'Product Import' },
    { match: '/superadmin/import-history', title: 'Import History' },
    {
      match: '/superadmin/all-payment-methods/',
      title: 'Payment Methods',
      startsWith: true,
    },
    {
      match: '/superadmin/add-payment-method/',
      title: 'Add Payment Method',
      startsWith: true,
    },
    {
      match: '/superadmin/all-subscriptions/',
      title: 'Subscriptions',
      startsWith: true,
    },
    {
      match: '/superadmin/add-subscription',
      title: 'Add Subscription',
      startsWith: true,
    },

    { match: '/owner/profile', title: 'Profile' },
    { match: '/owner/employee-management', title: 'Employee Management' },
    { match: '/owner/vendors', title: 'Vendors' },
    { match: '/owner/product-category', title: 'Product Category Management' },
    { match: '/owner/product-vendor', title: 'Product Vendor Management' },
    { match: '/owner/product-tag', title: 'Product Tag Management' },
    { match: '/owner/print-qr', title: 'Print QR Codes' },
    { match: '/owner/qr-code-generator', title: 'QR Code Settings', startsWith: true },
    { match: '/owner/add-qr-print', title: 'Print QR Codes' },
    { match: '/owner/qr-reprint', title: 'Re-print QR Codes' },
    { match: '/owner/batch-history', title: 'Print History By Batch' },
    { match: '/owner/print-history', title: 'Print History' },
    { match: '/owner/scanned-history', title: 'Scanned History' },
    { match: '/owner/review-qr-print', title: 'Print QR Codes' },
    { match: '/owner/landing-page-configuration', title: 'Landing Page Configuration' },
    { match: '/owner/landing-preview', title: 'Landing Page Preview', startsWith: true },
    { match: '/owner/quote-and-lead', title: 'Leads' },
    { match: '/owner/billing', title: 'Billing' },
    { match: '/owner/reports', title: 'Reports' },
    { match: '/owner/qr-scan-activity', title: 'QR Scan Activity' },
    { match: '/owner/vendors/import-history', title: 'Import History' },

    { match: '/manager/profile', title: 'Profile' },
    { match: '/manager/vendors', title: 'Vendors' },
    { match: '/manager/print-qr', title: 'Print QR Codes' },
    { match: '/manager/qr-code-generator', title: 'QR Code Settings', startsWith: true },
    { match: '/manager/add-qr-print', title: 'Print QR Codes' },
    { match: '/manager/qr-reprint', title: 'Re-print QR Codes' },
    { match: '/manager/batch-history', title: 'Print History By Batch' },
    { match: '/manager/print-history', title: 'Print History' },
    { match: '/manager/review-qr-print', title: 'Print QR Codes' },
    { match: '/manager/landing-page-configuration', title: 'Landing Page Configuration' },
    { match: '/manager/landing-preview', title: 'Landing Page Preview', startsWith: true },
    { match: '/manager/quote-and-lead', title: 'Leads' },
    { match: '/manager/employee-management', title: 'Employee Management' },
    { match: '/manager/vendors/import-history', title: 'Import History' },
    { match: '/manager/reports', title: 'Reports' },

    { match: '/employee/profile', title: 'Profile' },
    { match: '/employee/product-lookup', title: 'Vendors' },
    { match: '/employee/print-qr', title: 'Print QR Codes' },
    { match: '/employee/reports', title: 'Print QR Codes' },
  ];

  for (const route of routes) {
    if (route.startsWith) {
      if (path.startsWith(route.match)) return route.title;
    } else {
      if (path === route.match) return route.title;
    }
  }

  return 'Dashboard'; // default fallback
};
